module.exports = ".gallery\r\n{\r\n    display: inline-block;\r\n    margin-top: 20px;\r\n}"